import { Inject, PLATFORM_ID, Component, OnInit } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Deeplinks } from '@awesome-cordova-plugins/deeplinks/ngx';
import { AlertController, Platform } from '@ionic/angular';
import { filter } from 'rxjs/operators';
import { SeoService } from './services/seo.service';
@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit {
  private readonly isBrowser: boolean;

  constructor(
    private deeplink: Deeplinks,
    private platform: Platform,
    private alertCtrl: AlertController,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private seoService: SeoService,
    @Inject(PLATFORM_ID) platformId: object
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  ngOnInit() {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => this.updateSeoForCurrentRoute());

    this.updateSeoForCurrentRoute();

    if (!this.isBrowser) {
      return;
    }

    this.platform.ready().then(() => {
      this.deeplink.route({
        '/creator': {
          target: 'creator'
        },
        '/calendar': {
          target: 'calendar'
        },
        '/skills': {
          target: 'creator/skills'
        }
      }).subscribe(data => {
        console.log('routing', data);
        this.presentAlert(data);
      });

      console.log(
        'Welcome to my portfolio. Would you like to discuss any software development work? Let`s chat.'
      );

      console.log(
        `
___  ____ _    _  _ _ ____ _  _ ____ _  _
|__] |__| |    |_/  | [__  |__| |__| |\\ |
|__] |  | |___ | \\_ | ___] |  | |  | | \\|
`
      );
    });
  }

  private updateSeoForCurrentRoute(): void {
    let currentRoute = this.activatedRoute;

    while (currentRoute.firstChild) {
      currentRoute = currentRoute.firstChild;
    }

    const seo = currentRoute.snapshot.data['seo'];

    if (seo) {
      this.seoService.update(seo, this.router.url);
    }
  }

  async presentAlert(data: any) {
    const alert = await this.alertCtrl.create({
      header: 'Matched',
      subHeader: data.$link.url,
      message: JSON.stringify(data),
      buttons: [{
        text: 'Go',
        handler: () => {
          this.router.navigateByUrl(data.$route.target);
        }
      }]
    });

    await alert.present();
  }
}
